import moment from 'moment'

export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9
    ? '早上好'
    : hour <= 11
    ? '上午好'
    : hour <= 13
    ? '中午好'
    : hour < 20
    ? '下午好'
    : '晚上好'
}

export function welcome() {
  const arr = [
    '休息一会儿吧',
    '准备吃什么呢?',
    '要不要打一把 DOTA',
    '我猜你可能累了'
  ]
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

// export function handleScrollHeader(callback) {
//   let timer = 0

//   let beforeScrollTop = window.pageYOffset
//   callback = callback || function() {}
//   window.addEventListener(
//     'scroll',
//     event => {
//       clearTimeout(timer)
//       timer = setTimeout(() => {
//         let direction = 'up'
//         const afterScrollTop = window.pageYOffset
//         const delta = afterScrollTop - beforeScrollTop
//         if (delta === 0) {
//           return false
//         }
//         direction = delta > 0 ? 'down' : 'up'
//         callback(direction)
//         beforeScrollTop = afterScrollTop
//       }, 50)
//     },
//     false
//   )
// }

export function isIE() {
  const bw = window.navigator.userAgent
  const compare = s => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}

export function getVideoDuration(file) {
  return new Promise((resolve, reject) => {
    if (!/^video\/.*/.test(file.type)) {
      reject(new Error('该文件不是视频文件'))
    }
    window.URL = window.URL || window.webkitURL
    var video = document.createElement('video')
    video.preload = 'metadata'
    video.onloadedmetadata = function() {
      window.URL.revokeObjectURL(video.src)
      var duration = video.duration
      resolve(duration)
    }
    video.src = URL.createObjectURL(file)
  })
}

export function durationFormat(sec, pattern = 'HH:mm:ss') {
  let day = moment('2020-09-09')
  let value = sec + day.valueOf()
  let time = moment(value).format(pattern)
  return time
}
